import Vue from 'vue'

export default function({ state, rootState, commit, dispatch }, id) {
    commit('startLoadingRecords', id)

    return dispatch('get', {
        url: '/provider/' + state.id + '/survey/' + id
    }, {
        root: true
    })
    .then((response) => {
        commit('finishLoadingRecords', id)
        let responseRecord = response.record ?
            response.record.record.filter((record) => record.completed) :
            []
        console.log(responseRecord)
        Vue.set(state.surveyRecord, id, responseRecord)
        commit('content/cache', response.content, { root: true })
        return response
    })
    .catch((error) => {
        commit('finishLoading')
        console.log(error)
        throw error
    })
}
